import { ClientPortfolioDomainEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { EditBuildingSavingsForm } from "web_myplann/Portfolio/Pages/BuildingSavingsEdit/EditBuildingSavingsForm";
import { PortfolioEditLayout } from "web_myplann/Portfolio/PortfolioShared/PortfolioEditLayout";

export const EditBuildingSavingsPage = () => {
	const { t } = useResource();

	return (
		<PortfolioEditLayout
			expectedDomain={ClientPortfolioDomainEnum.BuildingSavings}
			title={t(Resources.Portfolio.EditPortfolio.title)}
		>
			{({ portfolio, portfolioId, detailRoute }) => (
				<EditBuildingSavingsForm
					portfolioId={portfolioId}
					portfolio={portfolio}
					detailRoute={detailRoute}
				/>
			)}
		</PortfolioEditLayout>
	);
};
